export interface IAccount {
  accessToken: string;
  userName: string;
  expires: Date;
  userId: string;
}

export enum AccountRoles {
  ADMINISTRATOR = 'administrator',
  INSTALLER = 'installer',
  HOME_OWNER = 'homeOwner'
}
